import React from 'react';
import ReactDOM from 'react-dom/client';
import '@anyemp/ui-kit/styles';

// Импортируем и инициализируем i18n перед любыми компонентами
import './services/i18n';

// Импортируем централизованную конфигурацию провайдеров
import { AppProviders } from './config/providers';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AppProviders>
    <App />
  </AppProviders>
);
